export var ROOT_FONT_SIZE = 16;
export var CONTAINER_MAX_WIDTH = 600;
